/**
 * 2019-11-28
 * handan
 * 获取屏幕的dpr
 */

class Dpr {
  getDpr(){
    let dpr = window.devicePixelRatio ;
    if(dpr){
      // let y = String(dpr).indexOf(".") + 1 ;
      // let count = String(dpr).length - y ;
      // if(count > 1){
      //   dpr = ( dpr * 1 ).toFixed(1) ;
      // }
      dpr = String(dpr).substring(0, 3) ;
    }else{
      dpr = "未知"
    }
    return dpr ;
  }
}

export default new Dpr() ;